import cemeteryBackground from '../../../../assets/fondocementerio.webp';
import nacanacaLogo from '../../../../assets/logo.webp';
import NohoCredit from './NohoCredit';

export const primary = [
  'w-full rounded-sm border border-[#F7E04B] bg-[#2E7D32] px-5 py-4',
  'font-black uppercase tracking-[.12em] text-white shadow-[4px_4px_0_#0A1A0F]',
  'transition-transform active:translate-x-0.5 active:translate-y-0.5 hover:bg-[#3A9D23]',
].join(' ');
export const replayButton = [
  'w-full rounded-sm border border-[#F7E04B] bg-[#7C3AED] px-5 py-4',
  'font-black uppercase tracking-[.12em] text-white shadow-[4px_4px_0_#0A1A0F]',
  'transition-transform active:translate-x-0.5 active:translate-y-0.5 hover:bg-[#6D2EB5]',
].join(' ');
export const secondary = 'w-full rounded-sm border border-[#7EC54A]/65 bg-[#0F1F12]/80 px-5 py-4 font-black uppercase tracking-[.12em] text-[#F7E04B] transition-colors active:bg-[#1A4D2E]';

export function Brand({ compact = false, centered = false, className = '' }) {
  return (
    <img
      src={nacanacaLogo}
      alt="Ñaca Ñaca"
      className={`h-auto object-contain ${compact ? 'w-24' : 'w-40'} ${centered ? 'mx-auto' : ''} ${className}`}
    />
  );
}

export function Panel({ children, wide = false, full = false, card = false, hideFooter = false }) {
  // Columna a altura completa: contenido centrado y footer después del contenido.
  return (
    <div
      className="fixed inset-x-0 top-0 z-50 h-[100dvh] overflow-y-auto bg-[#0A1A0F] px-5 pb-6 pt-[max(1.5rem,env(safe-area-inset-top))] text-center md:py-8"
      style={{
        backgroundImage: `url(${cemeteryBackground})`,
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundColor: '#0A1A0F',
        overscrollBehavior: 'none',
      }}
    >
      <div className="absolute inset-0 bg-black/15" aria-hidden="true" />
      <div className={`relative z-10 mx-auto flex min-h-full w-full flex-col ${full ? 'max-w-5xl' : wide ? 'max-w-lg' : 'max-w-sm'}`}>
        <section className={`m-auto w-full shrink-0 ${card ? 'border border-[#7C3AED]/60 bg-black/95 p-5 shadow-[10px_12px_0_rgba(0,0,0,.55)] md:p-7' : ''}`}>
          {children}
        </section>
        {!hideFooter && (
          <div className="flex shrink-0 justify-center pb-[max(.5rem,env(safe-area-inset-bottom))] pt-10">
            <NohoCredit variant="footer" />
          </div>
        )}
      </div>
    </div>
  );
}

export function Stat({ label, value }) {
  return (
    <div className="p-4 text-left even:border-l even:border-white/45">
      <p className="text-[9px] font-black uppercase tracking-[.16em] text-white">{label}</p>
      <p className="mt-1 text-xl font-black text-white">{value}</p>
    </div>
  );
}
